"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinuteSegmentTests = void 0;
var decrementMinutes_1 = require("./decrementMinutes");
var deleteMinutes_1 = require("./deleteMinutes");
var incrementMinutes_1 = require("./incrementMinutes");
var fromBlankMinutes_1 = require("./fromBlankMinutes");
var utils_1 = require("../../support/utils");
var MinuteSegmentTests = /** @class */ (function (_super) {
    __extends(MinuteSegmentTests, _super);
    function MinuteSegmentTests(utils) {
        var _this = _super.call(this, utils) || this;
        _this.increment = function () { return (0, incrementMinutes_1.incrementMinutes)(utils); };
        _this.decrement = function () { return (0, decrementMinutes_1.decrementMinutes)(utils); };
        _this.delete = function () { return (0, deleteMinutes_1.deleteMinutes)(utils); };
        _this.fromBlank = function () { return (0, fromBlankMinutes_1.fromBlankMinutes)(utils); };
        return _this;
    }
    return MinuteSegmentTests;
}(utils_1.TestSuite));
exports.MinuteSegmentTests = MinuteSegmentTests;
